import { useState } from 'react'

interface AgentAvatarProps {
  imageUrl?: string
  emoji?: string
  name: string
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export function AgentAvatar({
  imageUrl,
  emoji = '🤖',
  name,
  color = '#7C3AED',
  size = 48,
  className,
  style,
}: AgentAvatarProps) {
  const [imgError, setImgError] = useState(false)

  const showImage = !!imageUrl && imageUrl.trim() !== '' && !imgError

  const containerStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: showImage ? 'transparent' : `${color}22`,
    border: `2px solid ${color}44`,
    ...style,
  }

  if (showImage) {
    return (
      <div style={containerStyle} className={className}>
        <img
          src={imageUrl}
          alt={name}
          onError={() => setImgError(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '50%',
          }}
        />
      </div>
    )
  }

  return (
    <div style={containerStyle} className={className}>
      <span style={{ fontSize: size * 0.5, lineHeight: 1 }}>{emoji}</span>
    </div>
  )
}
